import { useCallback, useContext } from 'react'
import { getIdsHealthcareservicesHcsId } from '@toktokdoctech/tokapi-client'
import { CurrentHcsContext } from './CurrentHcsContext'

export const currentHcsStorageKey = 'currentHcs'

export const useSelectHcs = () => {
    const { setCurrentHcs } = useContext(CurrentHcsContext)

    return useCallback(
        async (healthCareServiceId: string) => {
            const newCurrentHcs = await getIdsHealthcareservicesHcsId(healthCareServiceId)
            setCurrentHcs(newCurrentHcs)
            localStorage.setItem(currentHcsStorageKey, newCurrentHcs.id)
        },
        [setCurrentHcs],
    )
}
